import 'regenerator-runtime/runtime';

const SEARCH_ASP_PRODUCTS_CART_LOCAL_STORAGE_KEY = 'linhaiSearchAspProductsCart';
const API_URL = 'https://api.parts.motoparts.md/api/price-list/linhai/';
const API_TOKEN_PROD = '2924f5e6a3d090cff6d39682bac5eec8b8cffc5de1ee771dd75a95bec014fa2d7f5269aaed7e337d959d2bfd867ae7edb15819826f0792ca81d9f874ce7b81e6f17740374369b456c3c8afcf2fe2938c0ead1fcb29385fd0045e6f39f6ed0e26a82bbf6164def1d2f81fd23d67927d6513d4ba99155f3d7a3636de6d481c9cd7';
const API_TOKEN_LOCAL = '537a69aa533b34509735cf1f45ca201d17c42dfd90ea1dfa084c7080149024a2ec5ac6de7f16b7973cf345ef2504a1487c7217112ba70ce288b3c681113b688325013ba1b6d8a3e3996557f2f2ebb90be58e703ab976f3e3f7b9265be3270315f392a7ac78a2642f4f05f7a75316308b7347fcbd579566b75e2e35b52d2abd47';
const API_TOKEN = API_TOKEN_PROD;
export function generateAspProductCardFromData(data) {
    const {
        url,
        name,
        productId,
        manufacturer,
        barcode,
        weight,
        availability,
        price,
        images = [],
        shortDescription,
        fullDetails,
        parameters,
        downloads,
    } = data;

    const imagesHtml = images?.length
        ? images.map((image, index) => {
           return `<div class="swiper-slide">
                <img class="swiper-lazy" ${index === 0 ? '' : 'data-'}src="${image.full}" alt="${name}">
            </div>`;
        }).join('\n')
        : ``;
    const downloadsHtml = downloads?.length
        ? `<div class="block-product-cards__downloads"><p><strong>Downloads:</strong></p><ul>${downloads.map((file) => `<li><a href="${file.link}" target="_blank">${file.name}</a></li>`).join('\n')}</ul></div>`
        : ``;
    const availabilityHtml = availability
        ? `<p class="block-product-cards__availability">${availability}</p>`
        : ``;

    const card = `
    <div class="block-product-cards__wrapper">
        <div class="block-product-cards__product" data-url="${url}" data-product-id="${productId}" data-name="${name}" data-price="${price}">
            <button class="close-modal button"><i class="mpb-icon-close"></i></button>
            <div class="block-product-cards__name clamp" title="${name}">${name}</div>                        
            <div class="block-product-cards__images">
                <div class="swiper swiper--manual-init" data-swiper-autoplay="2000">
                    <div class="swiper-wrapper">
                        ${imagesHtml}
                    </div>
                    <div class="swiper-pagination swiper-pagination-clickable"></div>
                </div>
            </div>
            <div class="block-product-cards__description clamp" title="${shortDescription}">${shortDescription}</div>
            <div class="block-product-cards__full-description">
                ${fullDetails ?? shortDescription ?? ``}
                ${downloadsHtml}
            </div>
            <div class="block-product-cards__manufacturer" title="${manufacturer}">Producator: <span>${manufacturer}</span></div>
            <div class="block-product-cards__code" title="${productId}">COD: <span>${productId}</span></div>
            <div class="block-product-cards__price" title="${price}">${price}€</div>
            <button class="block-product-cards__add-to-cart button button--square">
                <i class="mpb-icon-cart"></i>
            </button>
        </div>
    </div>`;
    return card;
}

export async function doSearchAspProducts(e) {
    e?.preventDefault();
    const formData = $(this).serialize();
    const url = `${API_URL}?${formData}`;
    const requestOptions = {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${API_TOKEN}`,
        },
        // mode: 'no-cors',
        // crossDomain: true,
        // redirect: "follow",
    };

    let request;
    let response;
    const cardsContainer = $(this).closest('.block-search-asp-products').find('.block-product-cards');
    const submitButton = $(this).find('button, input');
    submitButton.prop('disabled', true);
    cardsContainer.html(`<div></div><div class="block-search-asp-products__loading-spinner"><i class="mpb-icon-loader animate animate__rotation animate--linear animate--infinite"></i></div><div></div>`);
    try {
        request = await fetch(url, requestOptions);
    } catch (error) {
        submitButton.prop('disabled', false);
        cardsContainer.html('<p></p><p style="text-align: center;">A apărut o eroare de căutare, vă rugăm să încercați din nou</p><p></p>');
        console.error(error);
        return;
    }
    submitButton.prop('disabled', false);
    response = await request.json();
    if (response.data.length) {
        const cards = response.data.map(data => generateAspProductCardFromData(data)).join('\n\n');
        cardsContainer.html(cards);
    } else {
        cardsContainer.html('<p></p><p style="text-align: center;">Nici un rezultat gasit</p><p></p>');
    }
}

export function appendProductToCart(e) {
    e?.stopPropagation();
    const data = $(this).closest('.block-product-cards__product').data();

    let savedCart = localStorage.getItem(SEARCH_ASP_PRODUCTS_CART_LOCAL_STORAGE_KEY);
    let parsedCart = [];
    if (savedCart) {
        try {
            parsedCart = JSON.parse(savedCart);
        } catch (error) {
            console.log('Parse error', error);
            parsedCart = [];
        }
    }
    $(this).prop('disabled', true);
    if (parsedCart.some(i => i.productId === data.productId)) {
        console.log('Product already exist in cart', data);
        return;
    }
    parsedCart.push({...data, qty: 1});
    localStorage.setItem(SEARCH_ASP_PRODUCTS_CART_LOCAL_STORAGE_KEY, JSON.stringify(parsedCart));
    populateCartDataIntoForm();
}

export function clearProductFormCart() {
    localStorage.setItem(SEARCH_ASP_PRODUCTS_CART_LOCAL_STORAGE_KEY, JSON.stringify([]));
    populateCartDataIntoForm();
    $('.block-product-cards__add-to-cart').prop('disabled', false);
}

export function removeProductFromCart(e) {
    e?.stopPropagation();
    const data = $(this).closest('.block-search-asp-products__product-in-basket').data();
    let savedCart = localStorage.getItem(SEARCH_ASP_PRODUCTS_CART_LOCAL_STORAGE_KEY);
    let parsedCart = [];
    if (savedCart) {
        try {
            parsedCart = JSON.parse(savedCart);
        } catch (error) {
            console.log('Parse error', error);
            parsedCart = [];
        }
    }
    const newCart = parsedCart.filter(item => item.productId !== data.productId);
    localStorage.setItem(SEARCH_ASP_PRODUCTS_CART_LOCAL_STORAGE_KEY, JSON.stringify(newCart));
    populateCartDataIntoForm();
}


export function changeProductCartQty(count = 0) {
    const data = $(this).closest('.block-search-asp-products__product-in-basket').data();
    let savedCart = localStorage.getItem(SEARCH_ASP_PRODUCTS_CART_LOCAL_STORAGE_KEY);
    let parsedCart = [];
    if (savedCart) {
        try {
            parsedCart = JSON.parse(savedCart);
        } catch (error) {
            console.log('Parse error', error);
            parsedCart = [];
        }
    }
    const productIndex = parsedCart.findIndex(item => item.productId === data.productId);
    if (parsedCart[productIndex]?.qty > 1 || count > 0) {
        parsedCart[productIndex].qty = parsedCart[productIndex].qty + count;
    }
    localStorage.setItem(SEARCH_ASP_PRODUCTS_CART_LOCAL_STORAGE_KEY, JSON.stringify(parsedCart));
    populateCartDataIntoForm();
}

export function plusProductCartQty(e) {
    e?.stopPropagation();
    changeProductCartQty.call(this, 1);
}

export function minusProductCartQty(e) {
    e?.stopPropagation();
    changeProductCartQty.call(this, -1);
}

export function populateCartDataIntoForm(e, data) {
    const formContainer = $('.block-search-asp-products .block-search-asp-products__basket-form');

    if (!formContainer) {
        return;
    }

    let savedCart = localStorage.getItem(SEARCH_ASP_PRODUCTS_CART_LOCAL_STORAGE_KEY);
    let parsedCart = [];
    if (savedCart) {
        try {
            parsedCart = JSON.parse(savedCart);
        } catch (error) {
            console.log('Parse error', error);
            parsedCart = [];
        }
    }

    const totalPriceInCart = parsedCart.reduce((acc, item) => {
        acc = acc + item.price * item.qty;
        return acc;
    }, 0).toFixed(2);

    const formMessage = parsedCart.map(
        ({productId, name, price, url, qty, ...rest}, index) => {
            return `#${index+1}\nProduct: ${name}\nPart number: ${productId}\nPrice: ${price}€\nQty: ${qty}\nUrl: ${url}`;
        }
    ).join(`\n\n\n`) + `\n\n\nTotal ${totalPriceInCart}€\n\n\n`;
    formContainer.find('textarea[name="your-basket"]').val(formMessage);
    formContainer.find('input[name="your-subject"]').val(`New Linhai parts order`);

    $('.block-search-asp-products .block-search-asp-products__cart-button span').html(`(${parsedCart.length})`);

    const formItemsInCart = parsedCart.length
        ? parsedCart.map(({productId, name, price, url, qty, ...rest}, index) => `
            <tr class="block-search-asp-products__product-in-basket" data-item-index="${index}" data-product-id="${productId}">
                <td class="block-search-asp-products__basket-item-part-number" data-label="Part number">${productId}</td>
                <td class="block-search-asp-products__basket-item-name" data-label="Product name">${name}</td>
                <td class="block-search-asp-products__basket-item-price" data-label="Price">${price}€</td>
                <td class="block-search-asp-products__basket-item-qty" data-label="Qty">
                    <button class="block-search-asp-products__basket-item-qty-minus button button--square"><i class="mpb-icon-remove"></i></button>
                    <span>${qty}</span>
                    <button class="block-search-asp-products__basket-item-qty-plus button button--square"><i class="mpb-icon-add"></i></button>
                </td>
                <td class="block-search-asp-products__basket-item-remove" data-label="Remove">
                    <button class="button button--square"><i class="mpb-icon-bin"></i></button>
                </td>
            </tr>
        `).join(`\n\n`)
        : `
            <tr>
                <td colspan="5" class="block-search-asp-products__empty-cart">No products in cart</td>
            </tr>
        `;
    formContainer.find('.block-search-asp-products__basket-items tbody').html(formItemsInCart);

    const tfoot = parsedCart.length
        ? `
            <tr>
                <td colspan="5">Total: ${totalPriceInCart}€</td>
            </tr>
        `
        : ``;
    formContainer.find('.block-search-asp-products__basket-items tfoot').html(tfoot);

    return formMessage;
}

export function openCartFormModal(e) {
    e?.preventDefault();

    populateCartDataIntoForm();

    const basketForm = $(this).closest('.block-search-asp-products').find('.block-search-asp-products__basket-form');
    if ($('.block-search-asp-products__basket-form.active').length) {
        return;
    }
    if (!basketForm.hasClass('active')) {
        $('.block-search-asp-products__basket-form').removeClass('active');
    }
    basketForm.addClass('active');
    $('body').addClass('modal-opened');
}

export function closeCartFormModal(e, basketForm) {
    e?.stopPropagation();
    basketForm = basketForm ?? $(this).closest('.block-search-asp-products__basket-form');
    basketForm.removeClass('active');
    $('body').removeClass('modal-opened');
}

export function cartFormModalOnClickOutside(e) {
    if ($(e.target).closest(".block-search-asp-products__basket-form.active").length === 0) {
        const activeBasketForm = $('.block-search-asp-products__basket-form.active');
        closeCartFormModal(e, activeBasketForm);
    }
}

export function onCartSubmit(event) {
    const formId = $(`.block-search-asp-products__basket-form form input[name="_wpcf7"]`).val();
    console.log('Form submitted', event.detail);
    if (+formId === +(event.detail?.contactFormId)) {
        clearProductFormCart();
    }
}

export default function init() {
    $(document).on('submit', '.block-search-asp-products .block-search-asp-products__search-form', doSearchAspProducts);
    $(document).on('click', '.block-search-asp-products .block-product-cards__add-to-cart', appendProductToCart);
    $(document).on('click', '.block-search-asp-products .block-search-asp-products__basket-item-remove button', removeProductFromCart);
    $(document).on('click', '.block-search-asp-products .block-search-asp-products__basket-item-qty-minus', minusProductCartQty);
    $(document).on('click', '.block-search-asp-products .block-search-asp-products__basket-item-qty-plus', plusProductCartQty);
    $(document).on('click', '.block-search-asp-products .block-search-asp-products__cart-button', openCartFormModal);
    $(document).on('click', '.block-search-asp-products .block-search-asp-products__basket-form .close-modal', closeCartFormModal);
    $(document).on('click', 'body.modal-opened', cartFormModalOnClickOutside);
    populateCartDataIntoForm();

    document.addEventListener( 'wpcf7submit', onCartSubmit, false );
}